<template>
  <div class="gateway">
    <div class="gateway-m">
      <el-form
        :inline="true"
        :model="queryForm"
        class="demo-form-inline toolbar"
        style="padding-bottom:0px;"
      >
        <el-form-item label="读卡器编号">
          <el-input
            v-model="queryForm.readerNo"
            clearable
            style="width:250px;"
            placeholder="请输入读卡器编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="门禁卡编号">
          <el-input
            v-model="queryForm.labelNo"
            clearable
            style="width:250px;"
            placeholder="请输入门禁卡编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="持卡人姓名">
          <el-input
            v-model="queryForm.oldmanName"
            clearable
            style="width:250px;"
            placeholder="请输入持卡人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-date-picker
            v-model="queryForm.startQueryTime"
            type="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开始查询日期"
            :picker-options="pickerOptionsStart"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="queryForm.endQueryTime"
            type="date"
            value-format="yyyy-MM-dd "
            placeholder="选择结束查询日期"
            :picker-options="pickerOptionsEnd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="RfIdEvent">导出</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-printer" @click="printOut">打印</el-button>
        </el-form-item>
      </el-form>

      <div v-loading="loading" element-loading-text="拼命加载中......">
        <div class="table-page">
          <i-table :list="list" :options="options" :columns="columns" :operates="operates"></i-table>
        </div>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import iTable from "@/components/iTable.vue";
import { baseURL } from "@/utils/request.js";
export default {
  components: { iTable },
  data() {
    return {
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      maxPageSize: 999999,
      totalDataNumber: 0, //数据的总数,
      readerId: this.$route.query.readerId || "", //门禁读卡器的id,
      labelId: this.$route.query.labelId || "", //门禁卡的id
      loading: "", //加载数据中
      queryForm: {
        readerNo: "",
        labelNo: "",
        oldmanName: "",
        startQueryTime: "",
        endQueryTime: null
      },
      pickerOptionsStart: {
        disabledDate: time => {
          if (this.queryForm.endQueryTime) {
            return time.getTime() > new Date(this.queryForm.endQueryTime).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          if (this.queryForm.startQueryTime) {
            return time.getTime() < new Date(this.queryForm.startQueryTime).getTime();
          }
        }
      },
      list: [],
      options: {
        stripe: true, // 是否为斑马纹 table
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        mutiSelect: false // 是否支持列表项选中功能
      }, // table 的参数
      columns: [
        {
          prop: "oldmanName",
          label: "持卡人姓名",
          align: "center"
        },
        {
          prop: "readerNo",
          label: "门禁读卡器编号",
          align: "center"
        },
        {
          prop: "labelNo",
          label: "门禁卡编号",
          align: "center"
        },
        {
          prop: "location",
          label: "位置",
          align: "center"
        },
        {
          prop: "roleName",
          label: "卡类型",
          align: "center"
        },
        {
          prop: "createdTime",
          label: "时间",
          align: "center"
        }
      ], // 需要展示的列
      operates: {
        width: 300,
        fixed: "right",
        offset: 20,
        list: []
      } // 列操作按钮
    };
  },
  methods: {
    //RfIdEvent 导出excel
    RfIdEvent() {
      //dmc/rfidEvent/deriveDmcRfidEvent
      let param = {
        pageNum: 1,
        pageSize: this.maxPageSize,
        readerNo: this.queryForm.readerNo,
        labelNo: this.queryForm.labelNo,
        oldmanName: this.queryForm.oldmanName,
        startQueryTime: this.queryForm.startQueryTime,
        endQueryTime:
          this.queryForm.endQueryTime != null
            ? this.queryForm.endQueryTime + "23:59:59"
            : ""
      };
      var url = "";
      if (param.readerNo != "") {
        url = url + "&readerNo=" + param.readerNo;
      }
      if (param.labelNo != "") {
        url = url + "&labelNo=" + param.labelNo;
      }
      if (param.oldmanName != "") {
        url = url + "&oldmanName=" + param.oldmanName;
      }
      if (param.startQueryTime != "" && param.endQueryTime != "") {
        url =
          url +
          "&startQueryTime=" +
          param.startQueryTime +
          "&endQueryTime=" +
          param.endQueryTime;
      }
      console.log(param);
      window.location.href =
        baseURL +
        "dmc/api/deriveDmcRfidEvent" +
        `?pageNum=1&pageSize=999999` +
        url;
    },
    // 打印
    printOut() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.maxPageSize,
        readerNo: this.queryForm.readerNo,
        labelNo: this.queryForm.labelNo,
        oldmanName: this.queryForm.oldmanName,
        startQueryTime: this.queryForm.startQueryTime,
        endQueryTime:
          this.queryForm.endQueryTime != null
            ? this.queryForm.endQueryTime + "23:59:59"
            : ""
      };
      console.log(param);
      this.$postJson(
        "dmc/rfidEvent/queryDmcRfidEventWithRoleListWithPage",
        param
      ).then(res => {
        console.log(res);
        //判断是否有数据
        if (res.result.list.length != 0) {
        } else {
          this.$message({ message: "暂未找到打印的内容", type: "error" });
        }
      });
    },
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #e4f5f8";
      } else {
        return "background-color: #f9f9f9";
      }
    },
    //修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#bee1f4;color:#6f7075;font-weight: 500;";
      }
    },
    //查询
    onSubmit() {
      this.getTableData();
    },
    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.inputdeviceno != null) {
        this.onSubmit();
      }
    },

    //获取所有的门禁卡事件数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        readerNo: this.queryForm.readerNo,
        labelNo: this.queryForm.labelNo,
        oldmanName: this.queryForm.oldmanName,
        startQueryTime: this.queryForm.startQueryTime,
        endQueryTime:
          this.queryForm.endQueryTime != null
            ? this.queryForm.endQueryTime + "23:59:59"
            : ""
      };
      console.log(param);
      this.$postJson(
        "dmc/rfidEvent/queryDmcRfidEventWithRoleListWithPage",
        param
      ).then(res => {
        console.log(res);
        //判断是否有数据
        if (res.result.list.length != 0) {
          this.pageSize = res.result.pageSize;
          this.currentPage = res.result.pageNum;
          this.totalDataNumber = res.result.total * 1;
          this.list = res.result.list;
          console.log(this.list);
          setTimeout(() => {
            this.loading = false;
          }, 200);
        } else {
          this.list = [];
          this.totalDataNumber = 0;
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        }
      });
    },
    // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getTableData();
    }
  },
  created() {
    this.getTableData();
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.gateway {
  .gateway-m {
    padding: 10px 0 0 5px;
  }
}
//修改element-ui默认的样式
.exitrecord {
  color: green !important;
  margin-right: 10px;
}
.del {
  color: red !important;
}
.fenye {
  padding: 30px 0;
  background: #fff;
}
.el-dialog__header {
  height: 200px !important;
}
</style>


